export default __webpack_public_path__ + "8fa9b4edce89c69a6ecfb446a1a7387f.png";